<template>
  <div id="modalAlterStatusCourse" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Alterar Status do Curso</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="updateStatus">
          <div class="modal-body pb-1">
            <p>Status: <span class="text-danger">*</span></p>
            <div class="form-check form-check-inline">
              <input
                type="radio"
                class="form-check-input"
                id="statusInativo"
                value="0"
                v-model="course.status"
              />
              <label class="form-check-label" for="statusInativo">
                Inativo
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                type="radio"
                class="form-check-input"
                id="statusEmEdicao"
                value="2"
                v-model="course.status"
              />
              <label class="form-check-label" for="statusEmEdicao">
                Em Edição
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                type="radio"
                class="form-check-input"
                id="statusAtivo"
                value="1"
                v-model="course.status"
              />
              <label class="form-check-label" for="statusAtivo"> Ativo </label>
            </div>
            <div class="alert alert-primary border-0 mt-3 mb-0 p-2">
              <small>
                <strong>Atenção</strong>: Apenas cursos ativos que são exibidos
                para os alunos!
              </small>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Alterar"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Alterar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'AlterStatusCourseModal',

  props: {
    courseId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      course: {},
      disableButton: false,
    }
  },

  methods: {
    async getCourse() {
      try {
        this.course = await this.$store.dispatch('getCourse', this.courseId)
        showModal('modalAlterStatusCourse')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async updateStatus() {
      this.disableButton = true
      try {
        const response = await this.$store.dispatch(
          'updateStatusCourse',
          this.course,
        )

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getCourse()
  },
}
</script>
